import { render, staticRenderFns } from "./SortGroup.vue?vue&type=template&id=29b7c50c&scoped=true&"
import script from "./SortGroup.vue?vue&type=script&lang=js&"
export * from "./SortGroup.vue?vue&type=script&lang=js&"
import style0 from "./SortGroup.vue?vue&type=style&index=0&id=29b7c50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7c50c",
  null
  
)

export default component.exports